import React, { useState } from "react";
import { useIntl } from "umi";
import { Bubble, Button, Icon } from "tea-component";
import { copyTextToClipboard } from "@/pages/datalab/utils/utils";
import './index.scss';

const ContactShow = (props: any) => {
  const { formatMessage } = useIntl();
  const [contentId, setContentId] = useState('');
  const content = contentId === 'dbl_common_copy_success' ? (<div className={'dbl-contact-copy-success'}><Icon type="success" style={{marginRight: '4px'}}/>{formatMessage({id: contentId})}</div>) : (contentId && formatMessage({id: contentId}));
  return (<div className={'dbl-dashboard-contact'}>
    <span>{formatMessage({id: 'dbl_dashboard_contact_prefix'})}</span>
    <Bubble content={content} dark>
      <span
        className={'dbl-dashboard-contact-btn'}
        onMouseEnter={() => setContentId('dbl_common_copy')}
        onMouseLeave={() => setContentId('')}
      >
        <Button
          type={'link'}
          onClick={() => {
            copyTextToClipboard(props?.email)?.then(() => {
              setContentId('dbl_common_copy_success');
            }, (err) => {
              console.error('联系人 复制错误: ', err);
              setContentId('dbl_common_copy_error');
            });
          }}
        >
          {props?.email || props?.userName}
        </Button>
      </span>
      
    
    </Bubble>
  
  </div>);
};

export default ContactShow;